export * from './university-page.component';
